import { serialize } from '@/@core/libs/serialize/util'
import Http from './http'
import HttpAi from './httpAi'

// TEMPLATES
export const briefTemplatesList = params => Http.get(`/content-brief-templates${serialize(params)}`)
export const briefTemplateById = id => Http.get(`/content-brief-templates/${id}`)
export const createBriefTemplate = params => Http.post('/content-brief-templates', params)
export const updateBriefTemplate = params => Http.put(`/content-brief-templates/${params.id}`, params)
export const deleteBriefTemplate = id => Http.delete(`/content-brief-templates/${id}`)

// PENDING DRAFTS (institutional blog AI generation review)
export const publishBriefTemplate = id => Http.post(`/content-brief-templates/${id}/publish`)
export const rewriteBriefTemplate = id => Http.post(`/content-brief-templates/${id}/rewrite`)
export const rejectBriefTemplate = id => Http.post(`/content-brief-templates/${id}/reject`)

// MANUAL TOPIC — a moderator tells us what happened; the draft (blog + social) is generated right away
export const createEditorialDraft = params => Http.post('/content-brief-templates/editorial-drafts', params)

// INSTITUTIONAL GENERATOR ON/OFF SWITCH — surfaced directly in blog posts admin
export const getInstitutionalGeneratorStatus = () => Http.get('/content-brief-templates/institutional-generator-status')
export const updateInstitutionalGeneratorStatus = enabled => Http.post('/content-brief-templates/institutional-generator-status', { enabled })

// SUGGESTIONS
export const briefSuggestionsList = params => Http.get(`/content-brief-suggestions${serialize(params)}`)
export const briefSuggestionById = id => Http.get(`/content-brief-suggestions/${id}`)
export const currentBriefSuggestion = () => Http.get('/content-brief-suggestions/current')
export const selectBriefs = (id, params) => Http.post(`/content-brief-suggestions/${id}/select`, params)
export const generateBriefSuggestions = () => Http.post('/content-brief-suggestions/generate')

// AI ENRICHMENT
export const enrichBriefs = params => HttpAi.post('/admin/enrich-briefs', params)
